import React from 'react'
import { Card, Col, Flex, Row, Typography } from 'antd'
import { motion } from 'framer-motion'
import { Breadcrumb, Teamcomponent, Prosection, Vision, Ourmission, Ourhistory, UnderlineDesign } from '../../components'

const { Text, Title } = Typography
const Aboutus = () => {

    const data = {
        title: 'Why Nextdoor Pros?',
        desc:'At Nextdoor Pros, we make it easy for clients and professionals to find each other, collaborate, and succeed. Whether you’re a client looking for reliable services or a pro ready to grow your business, Nextdoor Pros is your go-to platform.'
    }

   

    return (
        <>
            <Breadcrumb title='About Us' pageName='About Us' breadcrumb={[{to:'/',name:'Home'}]}/>
            <div className='padding-t mb-3'>
                <div className='container'>
                    <Row gutter={[24, 24]} justify={'center'}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Flex vertical gap={20} align='center' className='text-center'>
                                <Flex vertical align='center'>
                                    <Title level={2} className='m-0 gradient-text'>
                                        {
                                            data?.title
                                        }
                                    </Title>
                                    <UnderlineDesign />
                                </Flex>
                                <Text className='fs-16'>
                                {data?.desc}
                                </Text>
                            </Flex>
                        </Col>
                    </Row>
                </div>
            </div>
            <Prosection />
            <Ourmission />
            <Vision />
            <Ourhistory />
            <Teamcomponent/>
        </>
    )
}

export { Aboutus }